import { render, staticRenderFns } from "./DeviceSidebar.vue?vue&type=template&id=32c7cfe0&scoped=true&"
import script from "./DeviceSidebar.vue?vue&type=script&lang=js&"
export * from "./DeviceSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSidebar.vue?vue&type=style&index=0&id=32c7cfe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c7cfe0",
  null
  
)

export default component.exports